export const PANEL_BUTTON_SIZE = theme => theme.spacing(3.75); // NOTE: Uses non-standard quarter-multiple for better design fit
//
export const THUMBNAIL_DIMENSIONS = 115;
export const SMALL_THUMBNAIL_DIMENSIONS = 64;

export const CARD_LAYOUT_STYLES = {
  display: 'grid',
  gridTemplateColumns: 'auto auto 1fr auto',
  gridTemplateRows: 'auto 1fr auto',
  gridTemplateAreas: `
    "control thumb title action"
    "control thumb content content"
    "control thumb view view"
  `,
  gap: theme => `${theme.spacing(0.5)} 0`,
};

export const SIDE_PANEL_EXPAND_KEY = 'pl-left-side-expand';
